import React, { useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import classNames from "classnames";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { generateTestId, TestIDWrapper } from "../../shared/testids/testids";
import { ModalFeedback } from "../../modules/pages/feedback/ModalFeedback";
import { APIProgress } from "../../shared/progress/APIProgress";
import { UserDrawer } from "../../shared/drawers/UserDrawer";
import { BreadcrumbItem, COREBreadcrumb } from "./COREBreadcrumb";
import { CORELogo } from "../Content/CORELogo";
import "./CORETopHeader.less";
import { useIsMobileScreen } from "../../shared/customHoooks/useBreakpoint";
import { isDevEnv } from "../../shared/state/rest";
import { DevEnvTag } from "../../shared/tags/DevEnvTag";
import { MarketStatusIndicatorButton } from "../../shared/buttons/MarketsStatusIndicatorButton";
import { spacing } from "../../shared/global";

const HeaderLogo = (): JSX.Element => {
  return (
    <TestIDWrapper
      testID={generateTestId("page", "core-top-header-logo")}
      className={"logo-image"}
    >
      <CORELogo />
    </TestIDWrapper>
  );
};

const APIProgressComponent = () => {
  return (
    <div className={"top-header-progress-bar"}>
      <div className={"top-header-progress-bar-block"}>
        <APIProgress />
      </div>
      <div
        className={classnames([
          "top-header-logo-border",
          { "dev-env": isDevEnv() },
        ])}
      />
    </div>
  );
};

export const CORETopHeader: React.FC<{
  toggleMobileMenu?: () => void;
  breadcrumbs?: BreadcrumbItem[];
}> = ({ toggleMobileMenu, breadcrumbs }) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] =
    useState<boolean>(false);
  const isMobileScreen = useIsMobileScreen();
  const gap = isMobileScreen ? spacing.xxs : spacing.xs;

  return (
    <TestIDWrapper
      testID={generateTestId("page", "core-top-header-component")}
      className="core-top-header"
    >
      <Row
        align={"middle"}
        gutter={[gap, gap]}
        className={classnames(["top-header-row", { "dev-env": isDevEnv() }])}
      >
        {/* Left-side items */}
        {/* menu for mobile screen */}
        <Col
          className={classNames(
            "mobile-hamburger-icon-block",
            "mobile-hamburger-icon"
          )}
          onClick={toggleMobileMenu}
        >
          <TestIDWrapper
            testID={generateTestId("page", "core-top-header-hamburger-menu")}
            className={"core-top-header-hamburger-icon"}
          >
            <MenuOutlined />
          </TestIDWrapper>
        </Col>
        <Col className={classNames("top-header-logo", "top-header-logo-block")}>
          <Link to={"/"}>
            <HeaderLogo />
          </Link>
        </Col>
        {isDevEnv() && !isMobileScreen && (
          <Col className={"dev-env-tag-desktop"}>
            <DevEnvTag />
          </Col>
        )}
        {/* Breadcrumb will disappear when small screen and it will add more space between the hamburger menu and the right-side items */}
        <Col flex={"auto"}>
          <div className={"breadcrumb-top-header-block"}>
            <COREBreadcrumb
              testID={"page-header-title"}
              breadcrumbs={breadcrumbs}
            />
          </div>
        </Col>

        {/* Right-side items */}
        <Col flex={"none"} className="markets-status-indicator-block">
          <MarketStatusIndicatorButton />
        </Col>
        <Col className={"user-panel-top-header-block"}>
          <UserDrawer />
        </Col>
      </Row>
      <APIProgressComponent />

      {/* Logo and dev tag for mobile screen */}
      <Row className={"header-mobile-size-block"}>
        <Col className={"top-header-logo"}>
          <Link to={"/"}>
            <HeaderLogo />
          </Link>
        </Col>
        {isDevEnv() && (
          <Col>
            <DevEnvTag />
          </Col>
        )}
      </Row>
      <ModalFeedback
        isFeedbackModalOpen={isFeedbackModalOpen}
        setIsFeedbackModalOpen={setIsFeedbackModalOpen}
      />
    </TestIDWrapper>
  );
};
